module.exports = __webpack_public_path__ + "img/taichung2.04330840.jpg";